(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yam-bilan-routine"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const roots = document.querySelectorAll('.yam-bilan-routine');

    roots.forEach(async (root) => {
      const params = new URLSearchParams(window.location.search);
      const routineParam = params.get('routine');
      const isRoutinePreview = params.get('routine_preview') === '1';
      if (!routineParam) return;

      const parsedItems = routineParam
        .split(',')
        .map((item) => item.trim().split(':'))
        .map(([handle, variantId, quantity, mode]) => ({
          handle: /^[a-z0-9-]+$/.test(handle || '') ? handle : '',
          variantId: /^\d+$/.test(variantId || '') ? Number(variantId) : null,
          quantity: /^\d+$/.test(quantity || '') ? Math.max(1, Number(quantity)) : 1,
          previewMode: isRoutinePreview && ['subscription', 'one-time'].includes(mode) ? mode : null,
        }))
        .filter((item) => item.handle);

      if (!parsedItems.length) return;

      root.hidden = false;
      const loading = root.querySelector('.yam-bilan-routine__loading');
      const error = root.querySelector('.yam-bilan-routine__error');
      const productsContainer = root.querySelector('.yam-bilan-routine__products');
      const summary = root.querySelector('.yam-bilan-routine__summary');
      const totalElements = root.querySelectorAll('[data-routine-total]');
      const discountElement = root.querySelector('[data-routine-discount]');
      const submits = root.querySelectorAll('[data-routine-submit]');
      let isAdding = false;
      const discountCode = root.dataset.discountCode;
      const discountRate = Number(root.dataset.discountRate || 0);

      const locale = document.documentElement.lang || 'fr-FR';
      const currency = window.Shopify?.currency?.active || 'EUR';
      const money = new Intl.NumberFormat(locale, { style: 'currency', currency });
      let items = [];
      let currentCart = null;

      const getPlan = (product, allocation) => {
        for (const group of product.selling_plan_groups || []) {
          const plan = (group.selling_plans || []).find((candidate) => candidate.id === allocation.selling_plan_id);
          if (plan) return plan;
        }
        return null;
      };

      const bestAllocation = (variant) => {
        return [...(variant.selling_plan_allocations || [])].sort((a, b) => a.price - b.price)[0] || null;
      };

      const createChoice = ({ item, mode, label, detail, price, saving }) => {
        const wrapper = document.createElement('label');
        wrapper.className = `yam-bilan-routine__choice yam-bilan-routine__choice--${mode}`;

        const input = document.createElement('input');
        input.type = 'radio';
        input.name = `routine-mode-${item.variant.id}`;
        input.value = mode;
        input.checked = mode === item.selectedMode;

        const copy = document.createElement('span');
        const strong = document.createElement('strong');
        strong.textContent = label;
        const small = document.createElement('small');
        small.textContent = detail;
        copy.appendChild(strong);
        if (detail) copy.appendChild(small);

        const side = document.createElement('span');
        side.textContent = price == null ? '' : money.format(price / 100);
        if (saving) {
          const badge = document.createElement('small');
          badge.className = 'yam-bilan-routine__saving';
          badge.textContent = `${root.dataset.save} ${saving}%`;
          side.appendChild(badge);
        }

        wrapper.append(input, copy, side);
        return wrapper;
      };

      const getSelection = (item) => {
        const mode = root.querySelector(`input[name="routine-mode-${item.variant.id}"]:checked`)?.value || 'one-time';
        const quantity = mode === 'subscription' ? 1
          : Math.min(12, Math.max(1, Math.floor(Number(item.quantity) || 1)));
        return { item, mode, quantity };
      };

      const updateTotal = () => {
        let total = 0;
        let hasOneTime = false;
        let selectedCount = 0;

        items.forEach((item) => {
          const selection = getSelection(item);
          const { mode } = selection;
          item.card.classList.toggle('is-skipped', mode === 'skip');

          if (mode === 'skip') return;
          const { quantity } = getSelection(item);
          const price = mode === 'subscription' && item.allocation
            ? item.allocation.price
            : Math.round(item.variant.price * (1 - discountRate / 100));
          total += price * quantity;
          selectedCount += 1;
          if (mode === 'one-time') hasOneTime = true;
        });

        totalElements.forEach((element) => { element.textContent = money.format(total / 100); });
        discountElement.textContent = hasOneTime && discountCode ? root.dataset.applied : '';
        const emptyMessage = root.querySelector('[data-routine-empty]');
        emptyMessage.textContent = root.dataset.empty;
        emptyMessage.hidden = selectedCount > 0;
        submits.forEach((button) => {
          button.disabled = selectedCount === 0 || isAdding;
          button.textContent = isAdding ? root.dataset.adding : root.dataset.add;
        });
      };

      try {
        const cartResponse = await fetch(`${window.Shopify.routes.root}cart.js`);
        if (!cartResponse.ok) throw new Error(root.dataset.error);
        currentCart = await cartResponse.json();

        items = await Promise.all(parsedItems.map(async (requested) => {
          const response = await fetch(`${window.Shopify.routes.root}products/${requested.handle}.js`);
          if (!response.ok) throw new Error(root.dataset.error);
          const product = await response.json();
          const variant = product.variants.find((candidate) => candidate.id === requested.variantId)
            || product.variants.find((candidate) => candidate.available)
            || product.variants[0];
          const allocation = bestAllocation(variant);
          const existingLine = currentCart.items.find((line) => {
            return line.variant_id === variant.id && line.properties?._yam_bilan === '1';
          });
          const selectedMode = requested.previewMode
            ? (requested.previewMode === 'subscription' && allocation ? 'subscription' : 'one-time')
            : (existingLine?.selling_plan_allocation && allocation ? 'subscription' : 'one-time');
          const selectedQuantity = existingLine?.quantity || requested.quantity;
          return {
            ...requested,
            quantity: selectedQuantity,
            product,
            variant,
            allocation,
            plan: allocation ? getPlan(product, allocation) : null,
            selectedMode,
          };
        }));

        items.forEach((item) => {
          const card = document.createElement('article');
          card.className = 'yam-bilan-routine__card';

          const imageWrap = document.createElement('div');
          imageWrap.className = 'yam-bilan-routine__image-wrap';
          const image = document.createElement('img');
          image.className = 'yam-bilan-routine__image';
          image.src = item.variant.featured_image?.src || item.product.featured_image || '';
          image.alt = item.product.title;
          image.loading = 'lazy';
          image.width = 480;
          image.height = 480;
          imageWrap.appendChild(image);

          const content = document.createElement('div');
          content.className = 'yam-bilan-routine__content';
          const title = document.createElement('h2');
          title.textContent = item.product.title;
          const price = document.createElement('p');
          price.className = 'yam-bilan-routine__price';
          price.textContent = `${money.format(item.variant.price / 100)} ${root.dataset.each}`;

          const choices = document.createElement('fieldset');
          choices.className = 'yam-bilan-routine__choices';
          choices.appendChild(createChoice({
            item,
            mode: 'one-time',
            label: root.dataset.oneTime,
            detail: discountCode ? root.dataset.applied : '',
            price: Math.round(item.variant.price * (1 - discountRate / 100)),
            saving: discountRate || null,
          }));

          if (item.allocation) {
            const saving = Math.round((1 - item.allocation.price / item.variant.price) * 100);
            choices.appendChild(createChoice({
              item,
              mode: 'subscription',
              label: root.dataset.subscription,
              detail: item.plan?.description || item.plan?.name || root.dataset.subscriptionDetail,
              price: item.allocation.price,
              saving,
            }));
          } else {
            const noSubscription = document.createElement('p');
            noSubscription.textContent = /super\s*mag/i.test(item.product.title)
              ? root.dataset.noSubscription60
              : root.dataset.noSubscription;
            choices.appendChild(noSubscription);
          }

          choices.appendChild(createChoice({
            item,
            mode: 'skip',
            label: root.dataset.skip,
            detail: '',
            price: null,
          }));

          content.append(title, price, choices);
          item.card = card;
          card.append(imageWrap, content);
          productsContainer.appendChild(card);
        });

        root.addEventListener('change', updateTotal);
        loading.hidden = true;
        summary.hidden = false;
        root.querySelector('.yam-bilan-routine__topbar').hidden = false;
        updateTotal();
        const alignTopbar = () => {
          const cards = [...productsContainer.children];
          if (!cards.length) return;
          const bounds = cards.map((card) => card.getBoundingClientRect());
          const width = Math.max(...bounds.map((rect) => rect.right)) - Math.min(...bounds.map((rect) => rect.left));
          if (width > 0) root.style.setProperty('--routine-cards-width', `${width}px`);
        };
        alignTopbar();
        const layoutObserver = new ResizeObserver(alignTopbar);
        layoutObserver.observe(productsContainer);
        root.classList.add('is-ready');
      } catch (caughtError) {
        loading.hidden = true;
        error.hidden = false;
        error.textContent = caughtError.message || root.dataset.error;
        return;
      }

      const addRoutine = async () => {
        if (isAdding) return;
        updateTotal();
        const selection = items.map(getSelection).filter(({ mode }) => mode !== 'skip');
        if (!selection.length) return;
        isAdding = true;
        updateTotal();
        error.hidden = true;

        try {
          const cartResponse = await fetch(`${window.Shopify.routes.root}cart.js`);
          if (!cartResponse.ok) throw new Error(root.dataset.error);
          const cart = await cartResponse.json();
          const routineVariantIds = new Set(items.map((item) => item.variant.id));

          for (const line of cart.items.filter((cartItem) => routineVariantIds.has(cartItem.variant_id) && cartItem.properties?._yam_bilan === '1')) {
            const removeResponse = await fetch(`${window.Shopify.routes.root}cart/change.js`, {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ id: line.key, quantity: 0 }),
            });
            if (!removeResponse.ok) throw new Error(root.dataset.error);
          }

          const cartItems = selection.map(({ item, mode, quantity }) => {
            const cartItem = {
              id: item.variant.id,
              quantity,
              properties: { '_yam_bilan': '1' },
            };
            if (mode === 'subscription' && item.allocation) {
              cartItem.selling_plan = item.allocation.selling_plan_id;
            }
            return cartItem;
          });

          const addResponse = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              items: cartItems,
              sections: 'cart-drawer,cart-icon-bubble',
              sections_url: window.location.pathname,
            }),
          });
          const addedCart = await addResponse.json();
          if (!addResponse.ok) {
            throw new Error(typeof addedCart.description === 'string' ? addedCart.description : root.dataset.error);
          }
          let sections = addedCart.sections;
          const hasOneTime = selection.some(({ mode }) => mode === 'one-time');

          if (discountCode && hasOneTime) {
            await fetch(`${window.Shopify.routes.root}discount/${encodeURIComponent(discountCode)}?redirect=${encodeURIComponent(window.Shopify.routes.root + 'cart')}`, {
              credentials: 'same-origin',
            });
            const sectionsResponse = await fetch(`${window.Shopify.routes.root}?sections=cart-drawer,cart-icon-bubble`);
            if (sectionsResponse.ok) sections = await sectionsResponse.json();
          }

          const cartDrawer = document.querySelector('cart-drawer');
          if (cartDrawer && sections && typeof cartDrawer.renderContents === 'function') {
            cartDrawer.renderContents({ id: addedCart.items?.[0]?.id, sections });
            isAdding = false;
            updateTotal();
            return;
          }

          window.location.assign(`${window.Shopify.routes.root}cart`);
        } catch (caughtError) {
          error.hidden = false;
          error.textContent = caughtError.message || root.dataset.error;
          isAdding = false;
          updateTotal();
        }
      };
      submits.forEach((button) => button.addEventListener('click', addRoutine));
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yam-kit-sanguin-v2"] && !Shopify.designMode) return;
  try {
    
  (()=>{const bar=document.querySelector('[data-yam-kit-sticky]');const target=document.querySelector('#yam-kit-commande');if(!bar||!target)return;const observer=new IntersectionObserver(entries=>{bar.classList.toggle('is-visible',!entries[0].isIntersecting)},{threshold:0});observer.observe(target)})();

  } catch(e) { console.error(e); }
})();
})();
